import React, { Component } from 'react';
import request from "superagent";
import parser from "fast-xml-parser";
import SearchResult from "./SearchResult";
import Searchform from "./Searchform";
import { DO_ARRAY }  from './CheckboxInputBuilder';
import { CPN, ORD }  from './RadioInputBuilder';
import Itemlist from "./Itemlist";
import Paging from "./Paging";

//let INITXMLPATH = ""
//let INITXMLPATH = "./search.xml"

class App extends Component {
  constructor(props) {
    super(props)
    this.xmlPath = ""
    this.init_visible_pager= 5
    this.visible_pager = 5
    this.state = {
      items: [],
      pages:[],
      length: 0,
      totalPages: 0,
      currentCpn: 10,
      parameterOrd: ORD,
      parameterCpn: CPN,
      parameterDo: DO_ARRAY,
      parameterPage: 1,
      parameterKw: "",
      loading: true
    }
    this.urlSet = this.urlSet.bind(this)
    this.loadedJSON = this.loadedJSON.bind(this)
    this.setArray = this.setArray.bind(this)
    this.setDoArray = this.setDoArray.bind(this)
    this.setPagesArray = this.setPagesArray.bind(this)
    this.checkURLParameter = this.checkURLParameter.bind(this)
    this.loadSet = this.loadSet.bind(this)
  }

  componentWillMount(){
    let PARAMETER_KW = ""
    let PARAMETER_CPN = 10
    if (window.location.search){
      let PARAMETERS_ARRAY = window.location.search.split('?')[1].split('&')
      for (let key in PARAMETERS_ARRAY){
        let PARAMETER = PARAMETERS_ARRAY[key].split('=')
        if(PARAMETER[0] === "kw"){
          PARAMETER_KW = PARAMETER[1]
        }else if(PARAMETER[0] === "ord"){
          this.setArray(ORD, PARAMETER[1])
        }else if(PARAMETER[0] === "cpn"){
          PARAMETER_CPN = Number(PARAMETER[1])
          this.setArray(CPN, PARAMETER[1])
        }else if(PARAMETER[0] === encodeURI('do[]') && PARAMETER[1] !== "all"){
          this.setDoArray(PARAMETER[1])
        }
      }
      this.xmlPath = "https://search.olympus-global.com?"+ window.location.search.split('?')[1] + "&sxml=on"
      //this.xmlPath = "./search.xml?"+ window.location.search.split('?')[1] + "&sxml=on"
      this.setState({
        //pages: PAGES_ARRAY,
        currentCpn: PARAMETER_CPN,
        parameterOrd: ORD,
        parameterCpn: CPN,
        parameterDo: DO_ARRAY,
        parameterKw: PARAMETER_KW,
      })
    }
  }

  componentDidMount() {
    if(this.xmlPath === ""){
      this.xmlPath = "https://search.olympus-global.com?charset=utf-8&ie=u&domain=ja&cpn=10&ord=d&do[]=all&kw="+this.state.parameterKw+"&page=1&sxml=on"
      //this.xmlPath = "./search.xml?charset=utf-8&ie=u&domain=ja&cpn=10&ord=d&do[]=all&kw="+this.state.parameterKw+"&page=1&sxml=on"
      //this.xmlPath = "./no-items.xml?charset=utf-8&ie=u&domain=ja&cpn=10&ord=d&do[]=all&kw="+this.state.parameterKw+"&page=1&sxml=on"
    }

    request
      .get(this.xmlPath)
      .then(res => {
        const jsonObj = parser.parse(res.text);
        this.loadedJSON(jsonObj)
      })
      .catch(err => {
        // err.message, err.response
        console.error('データ読み込みに失敗しました。:' + err)
      })
  }

  urlSet (url) {
    this.xmlPath = url
    request
      .get(this.xmlPath)
      .then(res => {
        const jsonObj = parser.parse(res.text);
        this.loadedJSON(jsonObj)
      })
      .catch(err => {
        // err.message, err.response
        console.error('データ読み込みに失敗しました。:' + err)
        this.loadSet(false)
      })
  }

  loadSet (bool) {
    this.setState({
      loading: bool,
    })
  }

  //データを読み込んだとき
  loadedJSON (res) {
    if(res.results.search_result.result_num !== 0){
      let TOTAL_PAGES = Math.ceil(res.results.search_result.result_num / this.state.currentCpn)
      let PAGES_ARRAY = this.setPagesArray(1, TOTAL_PAGES)
      let PARAMETER_PAGE = 1
      if (window.location.search){
        let PARAMETERS_ARRAY = window.location.search.split('?')[1].split('&')
        for (let key in PARAMETERS_ARRAY){
          let PARAMETER = PARAMETERS_ARRAY[key].split('=')
          if(PARAMETER[0] === "page"){
            PARAMETER_PAGE = Number(PARAMETER[1])
            PAGES_ARRAY = this.setPagesArray(Number(PARAMETER[1]), TOTAL_PAGES)
          }
        }
      }
      // 抽出後、ステート更新
      this.setState({
        loading: false,
        pages: PAGES_ARRAY,
        parameterPage: PARAMETER_PAGE,
        items: res.results.search_result.search_contents,
        length: res.results.search_result.result_num,
        totalPages: TOTAL_PAGES,
      })
    }else{
      this.setState({
        loading: false,
        pages:[],
        items: [],
        length: 0,
        totalPages: 0,
      })
    }
    this.checkURLParameter()
  }

  //set all array
  setArray (array, param) {
    for (let i in array) {
       if (array[i].inputValue === param) {
          array[i].inputChecked = true
       }else{
          array[i].inputChecked = false
       }
     }
  }
  setDoArray (param) {
    for (let i in DO_ARRAY) {
       if (DO_ARRAY[i].inputValue === param) {
          DO_ARRAY[i].inputChecked = true
       }else if (DO_ARRAY[i].inputValue === "all"){
         DO_ARRAY[i].inputChecked = false
       }
     }
  }
  setPagesArray (current, total) {
    if (total < this.init_visible_pager) {
      this.visible_pager = total
    }else{
      this.visible_pager = this.init_visible_pager
    }

    let ARRAY = []

    if (current < 3) {
      for (let page = 1; page <= this.visible_pager; page++) {
        if(page > 0){
          ARRAY.push(page)
        }
      }
    } else if (current >= (total - this.visible_pager)) {
      for (let page = (total - this.visible_pager); page <= total; page++) {
        if(page > 0){
          ARRAY.push(page)
        }
      }
    } else {
      for (let page = (current - 2); page <= (current + 2); page++) {
        if(page > 0){
          ARRAY.push(page)
        }
      }
    }

    return ARRAY
  }

  //setState with url parameter
  checkURLParameter () {
    let PARAMETER_KW = ""
    let PARAMETER_CPN = 10
    if (window.location.search){
      let PARAMETERS_ARRAY = window.location.search.split('?')[1].split('&')
      for (let key in PARAMETERS_ARRAY){
        let PARAMETER = PARAMETERS_ARRAY[key].split('=')
        if(PARAMETER[0] === "kw"){
          PARAMETER_KW = PARAMETER[1]
        }else if(PARAMETER[0] === "ord"){
          this.setArray(ORD, PARAMETER[1])
        }else if(PARAMETER[0] === "cpn"){
          PARAMETER_CPN = Number(PARAMETER[1])
          this.setArray(CPN, PARAMETER[1])
        }else if(PARAMETER[0] === encodeURI('do[]') && PARAMETER[1] !== "all"){
          this.setDoArray(PARAMETER[1])
        }
      }
      this.setState({
        //pages: PAGES_ARRAY,
        currentCpn: PARAMETER_CPN,
        parameterOrd: ORD,
        parameterCpn: CPN,
        parameterDo: DO_ARRAY,
        parameterKw: PARAMETER_KW,
      })
    }
  }

  render() {

    if(this.state.loading){
      return (
        <div className="searchApp">
          <SearchResult keyword={this.state.parameterKw} itemsLength={this.state.length} />
          <Searchform parameterDo={this.state.parameterDo} parameterOrd={this.state.parameterOrd} parameterCpn={this.state.parameterCpn} parameterKw={this.state.parameterKw} urlSet={this.urlSet}/>
          <div className="searchApp_loader"><img src="/shared/images/icon-loading-01.svg" alt="データ読み込み中" /></div>
        </div>
      )
    }else{
      return(
        <div className="searchApp">
          <SearchResult keyword={this.state.parameterKw} itemsLength={this.state.length} />
          <Searchform parameterDo={this.state.parameterDo} parameterOrd={this.state.parameterOrd} parameterCpn={this.state.parameterCpn} parameterKw={this.state.parameterKw} urlSet={this.urlSet} loadSet={this.loadSet}/>
          {(() => {
              if(this.state.length === 0 && this.state.parameterKw !== ""){
                return (
                  <ul className="list-bullet-01">
                  <li>キーワードに誤字・脱字がないか確認してください</li>
                  <li>違うキーワードを試してください</li>
                  <li>キーワードの数を減らして試してください</li>
                  </ul>
                )
              }
          })()}
          <Itemlist items={this.state.items} itemsLength={this.state.length}/>
          <Paging parameterPage={this.state.parameterPage} totalPages={this.state.totalPages} pagesArray={this.state.pages} urlSet={this.urlSet} loadSet={this.loadSet}/>
          </div>
      )
    }
  }
}

export default App;
